import {
  createAdfoxHomeDataModel,
  IAdfoxHomeDataRequest,
  TAdfoxHomeDataResponse,
} from '@cian/api-models/monolith-python/cian-api/site/v1/adfox/home';
import { IHttpApi } from '@cian/http-api';

export function getAdfoxData({
  httpApi,
  parameters,
  subdomain,
}: {
  httpApi: IHttpApi;
  parameters: IAdfoxHomeDataRequest;
  subdomain: string;
}): Promise<TAdfoxHomeDataResponse> {
  return httpApi.fetch(createAdfoxHomeDataModel({ parameters }), { subdomain });
}
